module.exports = __webpack_public_path__ + "static/media/armstrong_logo.c6b1d4f7.svg";